import { Button } from "@/components/ui/button";
import { Calendar as CalendarIcon } from "lucide-react";
import {
  createCalendarEvent,
  generateGoogleCalendarUrl,
  generateOutlookCalendarUrl,
  downloadICS,
} from "@/lib/calendar";

interface Booking {
  service_name: string;
  service_category: string;
  booking_date: string;
  booking_time: string;
  duration: string;
}

const AddToCalendarButtons = ({ booking }: { booking: Booking }) => {
  const event = createCalendarEvent(booking);

  return (
    <div className="space-y-3">
      <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground font-medium flex items-center gap-2">
        <CalendarIcon size={14} className="text-primary" /> Add to Calendar
      </p>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          size="sm"
          className="rounded-none border-primary/30 hover:bg-primary/10 tracking-[0.15em] uppercase text-xs font-medium"
          onClick={() => window.open(generateGoogleCalendarUrl(event), "_blank")}
        >
          Google
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="rounded-none border-primary/30 hover:bg-primary/10 tracking-[0.15em] uppercase text-xs font-medium"
          onClick={() => downloadICS(event)}
        >
          Apple / iCal
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="rounded-none border-primary/30 hover:bg-primary/10 tracking-[0.15em] uppercase text-xs font-medium"
          onClick={() => window.open(generateOutlookCalendarUrl(event), "_blank")}
        >
          Outlook
        </Button>
      </div>
    </div>
  );
};

export default AddToCalendarButtons;
